export type CodeEventFilters = {
  eventId?: number;
};

export class CodeEvent {
  constructor(
    public readonly id: number,
    public readonly code: string,
    public readonly expired: boolean,
    public readonly eventId: number,
    public readonly consumerId?: number,
    public readonly expireDate?: Date,
  ) {}
}
